import CallOutCard from 'layout/header/components/CallOutCard';
import Menu from 'layout/header/components/Menu';
import { columnContainer, menuItemStyle } from 'layout/header/styles';

import { hasArrayValues } from 'utils/array/arrays';

import type { FC } from 'react';

const MegaMenu: FC<MegaMenu> = ({ menu, callOutCard }) => {
  const hasCalloutOrResource = callOutCard?.heading || callOutCard?.miniCallOuts;
  const hasMultipleMenus = hasArrayValues(menu) && menu.length > 1;

  const direction = hasCalloutOrResource || hasMultipleMenus ? 'row' : 'column';

  return (
    <div className="flex w-full flex-col gap-4 px-[36.5px] pb-[27px] pt-4">
      <div className={columnContainer({ direction })}>
        {(callOutCard?.heading || callOutCard?.miniCallOuts) && <CallOutCard {...callOutCard} />}
        {hasArrayValues(menu) &&
          menu.map(menuItem => (
            <div key={menuItem.label} className={menuItemStyle({ direction })}>
              <Menu {...menuItem} direction={direction} />
            </div>
          ))}
      </div>
    </div>
  );
};

export default MegaMenu;
